import { Box } from '@talos/kyoko';
import type { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';
import type { CollateralHealthMarkerRole } from './collateralStatusUtils';

export const COLLATERAL_HEALTH_MARKER_WIDTH_PX = 9;
export const COLLATERAL_HEALTH_MARKER_HEIGHT_PX = 7;

const Triangle = styled(Box)<{ $color: string; $placement: CollateralHealthMarkerRole }>`
  flex-shrink: 0;
  width: ${COLLATERAL_HEALTH_MARKER_WIDTH_PX}px;
  height: ${COLLATERAL_HEALTH_MARKER_HEIGHT_PX}px;
  background: ${({ $color }) => $color};
  clip-path: ${({ $placement }) =>
    $placement === 'above' ? 'polygon(0 0, 100% 0, 50% 100%)' : 'polygon(50% 0, 100% 100%, 0 100%)'};
`;

export function CollateralHealthMarkerTriangle({
  color,
  placement,
  ...props
}: {
  color: string;
  placement: CollateralHealthMarkerRole;
} & ComponentPropsWithoutRef<typeof Box>) {
  return <Triangle $color={color} $placement={placement} {...props} />;
}
